import React, { Component } from "react";
import axios from "axios";
// import { Link } from "react-router-dom";
import swal from 'sweetalert';
import $ from "jquery";
import NumberFormat from 'react-number-format';


import Header from "../common/Header";
import Sidebar from "./Sidebar";
import { Link } from "react-router-dom";


export class LandvestList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      homes: [],
      currentPage: 1,
      homesPerPage: 9,
      query: "",
      isLoading: true
    };
    this.handleClick = this.handleClick.bind(this);
  }

  queryField = (e) => {
    e.preventDefault();
    this.setState({
      query: e.target.value,
    });
    axios
      .get(`${axios.defaults.baseURL}/search-homes/${this.state.query}`)
      .then((response) => {
        //console.log(response);
        return response;
      })
      .then((json) => {
        if (json.data.success) {
          this.setState({ homes: json.data.homes });
        } else alert("Fetching Homes Failed!");
      })
      .catch((error) => {
        console.error(`An Error Occured! ${error}`);
      });
  };

  handleClick(event) {
    event.preventDefault();
    this.setState({
      currentPage: Number(event.target.id),
    });
  }

  componentDidMount() {
    this.fetchHomes();
  }

  fetchHomes = (e) => {
    axios
      .get(`${axios.defaults.baseURL}/lands`)
      .then((response) => {
        //console.log(response);
        return response;
      })
      .then((json) => {
        if (json.data.success) {
          this.setState({ homes: json.data.homes, isLoading: false });
        } else alert("Fetching Homes Failed!");
      })
      .catch((error) => {
        console.error(`An Error Occured! ${error}`);
      });
  };

  soldOut(id) {

    axios({
        method: 'get',
        url: `${axios.defaults.baseURL}/land-soldout/${id}`
        })
      .then((response) => {
        //console.log(response);
        return response;
      })
  };

  reActivate(id) {
    axios({
        method: 'get',
        url: `${axios.defaults.baseURL}/land-activate/${id}`
        })
      .then((response) => {
        //console.log(response);
        return response;
      })
  };

  render() {
    const { homes, currentPage, homesPerPage, isLoading } = this.state;

    // Logic for displaying homes
    const homesList = this.state.homes;
    const indexOfLastHome = currentPage * homesPerPage;
    const indexOfFirstHome = indexOfLastHome - homesPerPage;
    const currentHomes = homesList.slice(indexOfFirstHome, indexOfLastHome);

    const renderHomes = currentHomes.map((home, index) => {
      return (
        <div
          className="mb-5 col-md-6 col-lg-6 col-xl-4 col-12 order-2"
          key={home.id}
        >
          <div className="wrap dash-card-main bg-white position-relative">
            <div className="wrap px-2 position-absolute w-100">
              <div className="dash-card-main thumb bg-dark mt-2 shadow-xl bg-cover">
                <img
                  src={home.image}
                  className="plan-img"
                  alt=""
                />
              </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className="wrap p-4 pt-5">
              <div className="row mt-1 mb-2 pt-5">
                <div className="pt-2 col">
      <h6 className="text-primary mb-0 titlecase">{home.name} @ <NumberFormat value={home.price} displayType={'text'} thousandSeparator={true} prefix={'₦'} /> {home.type}</h6>
      <span className="badge text-light badge-primary">Duration: {home.duration} {
        home.type == "monthly" ? ('Months') : home.type == "weekly" ? ('Weeks') : home.type == "daily" ? ('Days') : null
      }</span>
                </div>
              </div>
            </div>
            <hr className="mt-0"></hr>
            <div className="wrap px-4 pb-4">
              <div className="row no-gutters">
                <div className="col mr-2">
                  <Link to={{pathname: `edit-land/${home.name}`}} className="btn w-100 btn-primary">
                    Edit
                  </Link>
                </div>
                <div className="col mr-2">
                    { home.status == "active" ? (
                        <Link onClick={this.soldOut.bind(this, home.id)} className="btn w-100 btn-danger">
                        Sold Out
                      </Link>
                    ) : home.status == "soldout"  ? (<Link onClick={this.reActivate.bind(this, home.id)} className="btn w-100 btn-warning">
                    Re-Activate
                  </Link>) : null
                    }
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });

    // Logic for displaying page numbers
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(homes.length / homesPerPage); i++) {
      pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map((number) => {
      return (
        <>
        { number == currentPage ? (
        <li
          className="pg-link active-link"
          key={number}
          id={number}
          onClick={this.handleClick}
        >
          {number}
        </li> 
        ) :
        <li
          className="pg-link"
          key={number}
          id={number}
          onClick={this.handleClick}
        >
          {number}
        </li> 
      }
      </>
      );
    });

    return (
      <div id="app" className="bg-gray-200">
        <div className="dashboard-page">
          <div className="private-layout">
            <div className="app-wrapper">
              <Sidebar />
              <Header />
              <div id="main-app" className="position-relative">
                <div className="container mt-4">
                  <div className="page-title">
                    <div className="row text-primary py-2 pt-4">
                      <div className="col-10">
                        <div
                          className="user-welcome"
                          style={{ overflow: "hidden" }}
                        >
                          <div className="wrapper d-flex">
                            <h4 className="d-inline-block">Landvest Lands</h4>
                          </div>
                          <Link to="/admin/new-land" className="btn btn-primary">
                            Add New Land <i className="fa fa-plus"></i>
                          </Link>
                        </div>
                      </div>
                      <div className="text-right col-2"></div>
                    </div>
                  </div>
                  <div className="row mt-4 align-items-stretch">
                    {/* Product Listing */}
                    {isLoading ? (
                      <>
                        <div className="mb-5 col-md-6 col-lg-6 col-xl-4 col-12 order-2">
                          <div className="wrap dash-card-main bg-white position-relative">
                            <div className="wrap px-2 position-absolute w-100">
                              <div className="dash-card-main mt-2 bg-cover blink_me">
                                Loading...
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-5 col-md-6 col-lg-6 col-xl-4 col-12 order-2">
                          <div className="wrap dash-card-main bg-white position-relative">
                            <div className="wrap px-2 position-absolute w-100">
                              <div className="dash-card-main mt-2 bg-cover blink_me">
                                Loading...
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-5 col-md-6 col-lg-6 col-xl-4 col-12 order-2">
                          <div className="wrap dash-card-main bg-white position-relative">
                            <div className="wrap px-2 position-absolute w-100">
                              <div className="dash-card-main mt-2 bg-cover blink_me">
                                Loading...
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>{renderHomes}</>
                    )}
                    {/* End Product Listing */}
                  </div>
                </div>
                  <div className="text-center">
                    {renderPageNumbers}
                  </div><br/><br/>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LandvestList;
